export default function TargetAudience() {
  const audiences = [
    {
      icon: 'ri-graduation-cap-line',
      title: 'طلاب الجامعات',
      description: 'من السنة الثانية فما فوق',
      stats: '60%',
      color: 'from-[#FF6B6B] to-[#FF8E53]'
    },
    {
      icon: 'ri-user-star-line',
      title: 'الخريجون الجدد',
      description: 'حتى 3 سنوات من التخرج',
      stats: '25%',
      color: 'from-[#FF8E53] to-[#FFA07A]'
    },
    {
      icon: 'ri-rocket-line',
      title: 'رواد الأعمال الناشئون',
      description: 'أصحاب المشاريع في مراحلها الأولى',
      stats: '15%',
      color: 'from-[#FFA07A] to-[#FFB88C]'
    }
  ];

  void audiences;

  const directBeneficiaries = [
    {
      icon: 'ri-graduation-cap-line',
      title: 'طلاب الجامعات',
      description: 'مساحة حرة للتعلم والنمو والاسترخاء'
    },
    {
      icon: 'ri-user-star-line',
      title: 'حديثو التخرج',
      description: 'بيئة لبناء المسار المهني وتطوير المهارات'
    },
    {
      icon: 'ri-rocket-line',
      title: 'رواد الأعمال',
      description: 'منصة لتحويل الأفكار إلى مشاريع ناجحة'
    }
  ];

  const indirectBeneficiaries = [
    {
      icon: 'ri-building-line',
      title: 'الجهات الراعية',
      description: 'الوصول للمواهب وبناء العلامة التجارية'
    },
    {
      icon: 'ri-school-line',
      title: 'الجامعات',
      description: 'ربط الطلاب بالفرص العملية'
    },
    {
      icon: 'ri-briefcase-line',
      title: 'سوق العمل',
      description: 'كفاءات مؤهلة وجاهزة للعمل'
    },
    {
      icon: 'ri-community-line',
      title: 'المجتمع المحلي',
      description: 'تنمية مستدامة وأثر اجتماعي إيجابي'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-white to-[#FFF5F3]">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            الفئات المستهدفة
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            نخدم مجموعة متنوعة من المستفيدين المباشرين وغير المباشرين
          </p>
        </div>

        {/* Direct Beneficiaries */}
        <div className="mb-20">
          <h3 className="text-3xl font-bold text-gray-900 mb-10 text-center">
            المستفيدون المباشرون
          </h3>
          <div className="grid md:grid-cols-3 gap-8">
            {directBeneficiaries.map((item, index) => (
              <div
                key={index}
                className="group bg-white p-8 rounded-2xl border border-gray-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
              >
                <div className="w-20 h-20 bg-gradient-to-br from-[#FF6B6B] to-[#FF8E53] rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <i className={`${item.icon} text-white text-4xl`}></i>
                </div>
                <h4 className="font-bold text-2xl text-gray-900 mb-3">
                  {item.title}
                </h4>
                <p className="text-gray-600 leading-relaxed text-lg">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Indirect Beneficiaries */}
        <div>
          <h3 className="text-3xl font-bold text-gray-900 mb-10 text-center">
            المستفيدون غير المباشرين
          </h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {indirectBeneficiaries.map((item, index) => (
              <div
                key={index}
                className="group bg-white p-8 rounded-2xl border border-gray-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-[#FF6B6B] to-[#FF8E53] rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <i className={`${item.icon} text-white text-3xl`}></i>
                </div>
                <h4 className="font-bold text-xl text-gray-900 mb-3">
                  {item.title}
                </h4>
                <p className="text-gray-600 leading-relaxed">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
